// Taşeron portalı — değeri geciktiren küçük hook (arama kutusu → istek gürültüsü azaltma).
// Her tuş vuruşunda değil, yazım durduktan `delay` ms sonra günceller. (web-expert
// useDebouncedValue deseniyle aynı — her app kendi lib'ini taşır.)

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delay = 350): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
